var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ws-icon',_vm._g(_vm._b({staticClass:"ws-edit",attrs:{"clickable":"","size":_vm.small ? 16 : 24,"name":"edit"}},'ws-icon',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }